import { useState } from "react";
import useUiuxStore from "src/store/useUiuxStore";
import { defaultPUR1030_R01Filter, usePUR1030_R01Store } from "src/containers/mes/PUR/PUR1030_R01/Store_PUR1030_R01";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { searchCustomer } from "src/apis/customerApi";

interface Props {
  onEnterKeyDown: () => void;
}

export const SearchSection_PUR1030_R01 = (props: Props) => {
	const { onEnterKeyDown } = props;
	const { PUR1030_R01Filter, setPUR1030_R01Filter } = usePUR1030_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { yesNoList } = useCommonCodeStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const custInfoHandleFoucsId = 'infoCustInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			}
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PUR1030_R01Filter,
		setEditData: setPUR1030_R01Filter,
		defaultData: defaultPUR1030_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR1030_R01_search'
	});

	return (
		<SearchSectionForm>
			<SearchDateRangeForm
				label="납기 조회 기간"
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]',
				}}
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={PUR1030_R01Filter.dateRange}
				setDateRange={(dateRange) => setPUR1030_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>

			<SearchInputForm
				label="발주번호"
				value={PUR1030_R01Filter.purchaseOrderNo}
				onChange={(e) => setPUR1030_R01Filter({ purchaseOrderNo: e.target.value })}
				onKeyDown={(e) => {
					if (e.key === 'Enter') onEnterKeyDown();
				}}
				initValue={() => setPUR1030_R01Filter({ purchaseOrderNo: '' })}
			/>

			<SearchCodeModalForm
				label="거래처"
				value={PUR1030_R01Filter.customCd}
				valueLabel={PUR1030_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
			<SearchDropDownForm
				label="발주마감포함"
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[70px] min-w-[70px]',
					selectStyle: 'w-[120px] min-w-[120px] ',
				}}
				value={PUR1030_R01Filter.orderStatus}
				onChangeItem={(item) => setPUR1030_R01Filter({ orderStatus: item?.minorCd || '' })}
				optionList={yesNoList}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_PUR1030_R01;